import Axios from 'axios';
import Qs from 'qs';

export default {

  // 取消原因分页列表
  listPage (
    page,
    per_page
  ) {
    return Axios.get('/property_repair/repair_cancel_order_reason', {
      params: {
        page,
        per_page
      }
    })
  },

  // 取消原因列表
  list () {
    return Axios.get('/property_repair/repair_cancel_order_reasons');
  },

  // 取消原因上线
  online (
    id
  ) {
    return Axios.post(`/property_repair/repair_cancel_order_reason/online/${id}`);
  },

  // 取消原因下线
  offline (
    id
  ) {
    return Axios.post(`/property_repair/repair_cancel_order_reason/offline/${id}`);
  },

  // 取消原因新增
  add (
    cancel_order_reason
  ) {
    return Axios.post('/property_repair/repair_cancel_order_reason', {
      cancel_order_reason
    });
  },

  // 取消原因编辑
  edit (
    id,
    cancel_order_reason
  ) {
    return Axios.put(`/property_repair/repair_cancel_order_reason/${id}`, {
      cancel_order_reason
    });
  },

  // 取消原因删除
  del (
    id
  ) {
    return Axios.delete(`/property_repair/repair_cancel_order_reason/${id}`);
  },

}